var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 350,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "White"), /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("title", null, "Logo"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    className: "cls-1",
    d: "m118.05,94.74l0,-85.36a1.15,1.15 0 0 0 -1.15,-1.16c-4.82,0 -23.32,-0.15 -28.11,-0.05a1.15,1.15 0 0 0 -1.13,1.16l0,115.8a1.17,1.17 0 0 0 1.17,1.17l275,0a8.53,8.53 0 0 0 8.53,-8.53l0,-5c0,-49.2 -51.1,-104.3 -114.13,-104.3l-115.8,0a12.14,12.14 0 0 0 -12.13,12.14l0,63a1.16,1.16 0 0 0 1.16,1.16l28.72,0a1.16,1.16 0 0 0 1.16,-1.16l0,-43.17a1.17,1.17 0 0 1 1.17,-1.17l75.36,0c63.19,0 94.68,47.45 94.68,56.63l-213.33,0a1.16,1.16 0 0 1 -1.17,-1.16z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    className: "cls-1",
    d: "m118.05,167.81l0,85.36a1.15,1.15 0 0 1 -1.15,1.16c-4.82,0 -23.32,0.15 -28.11,0a1.15,1.15 0 0 1 -1.13,-1.16l0,-115.75a1.16,1.16 0 0 1 1.17,-1.16l282.34,0a1.16,1.16 0 0 1 1.17,1.16l0,12.39c0,49.2 -51.1,104.3 -114.13,104.3l-126.75,0a1.16,1.16 0 0 1 -1.16,-1.17l0,-73.94a1.16,1.16 0 0 1 1.16,-1.17l28.72,0a1.16,1.16 0 0 1 1.16,1.17l0,43.14a1.17,1.17 0 0 0 1.17,1.17l75.36,0c60.47,0 91.9,-43.44 94.5,-55.24a1.16,1.16 0 0 0 -1.15,-1.39l-212,0a1.16,1.16 0 0 0 -1.17,1.13z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    className: "cls-1",
    d: "m18.36,315.43l-10.53,0l0,-3.82l25.41,0l0,3.82l-10.53,0l0,26.9l-4.35,0l0,-26.9z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    className: "cls-1",
    d: "m73.22,311.61l0,30.72l-4.39,0l0,-13.69l-17.64,0l0,13.69l-4.39,0l0,-30.72l4.39,0l0,13.21l17.64,0l0,-13.21l4.39,0z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    className: "cls-1",
    d: "m113.5,338.51l0,3.82l-22.29,0l0,-30.72l21.68,0l0,3.82l-17.29,0l0,9.44l15.4,0l0,3.73l-15.4,0l0,9.91l17.9,0z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    className: "cls-1",
    d: "m176.39,334c0,5.26 -4,8.29 -11.76,8.29l-14.63,0l0,-30.68l13.77,0c7.07,0 11,3 11,7.94a7.28,7.28 0 0 1 -4.13,6.85a7.43,7.43 0 0 1 5.75,7.6zm-22,-18.87l0,9.87l9,0c4.48,0 7,-1.67 7,-4.92s-2.54,-4.91 -7,-4.91l-9,-0.04zm17.61,18.56c0,-3.56 -2.63,-5.14 -7.5,-5.14l-10.1,0l0,10.23l10.1,0c4.83,0 7.5,-1.54 7.5,-5.09z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    className: "cls-1",
    d: "m189.47,327c0,-9 6.94,-15.71 16.37,-15.71s16.28,6.67 16.28,15.71s-6.93,15.71 -16.28,15.71s-16.37,-6.71 -16.37,-15.71zm28.26,0a11.94,11.94 0 1 0 -11.89,11.81a11.53,11.53 0 0 0 11.89,-11.81z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    className: "cls-1",
    d: "m237.61,311.61l12.95,0c9.87,0 16.59,6.23 16.59,15.36s-6.72,15.36 -16.59,15.36l-12.95,0l0,-30.72zm12.69,26.9c7.59,0 12.46,-4.65 12.46,-11.54s-4.87,-11.54 -12.46,-11.54l-8.3,0l0,23.08l8.3,0z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    className: "cls-1",
    d: "m293.09,331.71l0,10.62l-4.35,0l0,-10.71l-12.2,-20l4.7,0l9.83,16.19l9.87,-16.19l4.35,0l-12.2,20.09z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    className: "cls-1",
    d: "m339.08,311.61l4.39,0l0,26.9l16.63,0l0,3.82l-21,0l-0.02,-30.72z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    className: "cls-1",
    d: "m393.63,334.65l-16.33,0l-3.38,7.68l-4.52,0l13.91,-30.72l4.35,0l14,30.72l-4.66,0l-3.37,-7.68zm-1.54,-3.51l-6.63,-15l-6.62,15l13.25,0z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    className: "cls-1",
    d: "m441.37,334c0,5.26 -4,8.29 -11.76,8.29l-14.61,0l0,-30.68l13.78,0c7.06,0 11,3 11,7.94a7.29,7.29 0 0 1 -4.12,6.85a7.43,7.43 0 0 1 5.71,7.6zm-22,-18.87l0,9.87l9,0c4.48,0 7,-1.67 7,-4.92s-2.54,-4.91 -7,-4.91l-9,-0.04zm17.6,18.52c0,-3.56 -2.63,-5.14 -7.5,-5.14l-10.1,0l0,10.23l10.1,0c4.84,0.04 7.47,-1.5 7.47,-5.05l0.03,-0.04z",
    fill: "#fefefe"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1219ad8e0fb45b41064f19b9e9f62e6e.svg";
export { ForwardRef as ReactComponent };